import { render, staticRenderFns } from "./SendMessageTemplateTable.vue?vue&type=template&id=54e3e4ee&scoped=true&lang=pug"
import script from "./SendMessageTemplateTable.vue?vue&type=script&lang=ts"
export * from "./SendMessageTemplateTable.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTemplateTable.vue?vue&type=style&index=0&id=54e3e4ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e3e4ee",
  null
  
)

export default component.exports